import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import CreateAttendance from "../Staff-info/CreateAttendance";

export default function AttendanceList() {
  const [lists, setLists] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(30);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [staff, setStaff] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterValues, setFilterValues] = useState({
    staffId: "00000000-0000-0000-0000-000000000000",
    attendanceDate: new Date(),
  });
  const [showModal, setShowModal] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const userId = localStorage.getItem("userId");

  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  const handlefilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };

  const handleDateChange = (dates) => {
    setFilterValues({
      ...filterValues,
      attendanceDate: dates[0],
    });
  };

  const handleSearch = () => {
    GetData(1);
  };

  const handleclear = () => {
    setFilterValues({
      staffId: "00000000-0000-0000-0000-000000000000",
      attendanceDate: new Date(),
    });
    GetData(1);
  };

  const handleOpenModal = () => {
    setRecordForEdit(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setRecordForEdit(null);
    setRecordToDelete(null);
  };

  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETATTENDANCESUMMARY +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "&staffId=" +
          filterValues.staffId +
          "&attendanceDate=" +
          moment(filterValues.attendanceDate).format("YYYY-MM-DD") +
          "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };

  const GetStaff = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setStaff(response.data.data);
      });
  };

  useEffect(() => {
    GetStaff();
    GetData(pageNumber);
  }, []);

  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Attendance</h4>
                  <button className="btn btn-primary" onClick={handleOpenModal}>
                    Add Attendance
                  </button>
                </div>
              </div>
            </div>

            <div className="alert alert-success">
              <div className="row">
                <div className="col-lg-3">
                  <label htmlFor="staffId" className="form-label">
                    Staff
                  </label>
                  <select
                    name="staffId"
                    value={filterValues.staffId}
                    onChange={handlefilterChange}
                    className="form-select"
                  >
                    <option value="00000000-0000-0000-0000-000000000000">
                      All Staff
                    </option>
                    {staff.length > 0 &&
                      staff.map((c) => (
                        <option key={c.staffId} value={c.staffId}>
                          {c.staffName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-3">
                  <label htmlFor="attendancedate" className="form-label">
                    Attendance Date
                  </label>
                  <div className="input-group">
                    <Flatpickr
                      value={filterValues.attendanceDate}
                      options={{
                        dateFormat: "d-M-Y",
                        maxDate: "today",
                        defaultDate: new Date(),
                      }}
                      className="form-control"
                      onChange={handleDateChange}
                      placeholder={moment(new Date()).format("DD-MMM-YYYY")}
                    />
                    <div className="input-group-text bg-primary border-primary text-white">
                      <i className="ri-calendar-2-line" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger w-100"
                      onClick={handleclear}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Staff</th>
                            <th>Attendance Date</th>
                            <th>CheckIn</th>
                            <th>CheckOut</th>
                            <th>TotalHoursWorked</th>
                            <th>TotalOverTime</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.attendanceId}>
                                <td>{index + 1}</td>
                                <td>{v.staffName}</td>
                                <td>
                                  {moment(v.attendanceDate).format(
                                    "DD-MMM-YYYY"
                                  )}
                                </td>
                                <td>{moment(v.checkIn).format("hh:mm a")}</td>
                                <td>
                                  {v.checkOut === "0001-01-01T00:00:00"
                                    ? "--"
                                    : moment(v.checkOut).format("hh:mm a")}
                                </td>
                                <td>
                                  {Math.floor(v.totalWorkingHours)}h :
                                  {Math.round((v.totalWorkingHours % 1) * 60)
                                    .toString()
                                    .padStart(2, "0")}
                                  m
                                </td>
                                <td>
                                  {Math.floor(v.totalOverTime)}h :
                                  {Math.round((v.totalOverTime % 1) * 60)
                                    .toString()
                                    .padStart(2, "0")}
                                  m
                                </td>
                                <td
                                  style={{
                                    color:
                                      v.status === "CheckedIn"
                                        ? "red"
                                        : v.status === "CheckedOut"
                                        ? "green"
                                        : "black",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {v.status}
                                </td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Edit"
                                    >
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => {
                                          setRecordForEdit(v);
                                          setShowModal(true);
                                        }}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Delete"
                                    >
                                      <Link
                                        className="remove-item-btn"
                                        onClick={() => {
                                          setRecordToDelete(v.attendanceId);
                                          setShowModal(true);
                                        }}
                                      >
                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No records found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                        >
                          <Link
                            className="page-link"
                            onClick={() => GetPageData(pageNumber - 1)}
                          >
                            Previous
                          </Link>
                        </li>
                        {renderPageNumbers}
                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                        >
                          <Link
                            className="page-link"
                            onClick={() => GetPageData(pageNumber + 1)}
                          >
                            Next
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CreateAttendance
              showModal={showModal}
              handleCloseModal={handleCloseModal}
              recordForEdit={recordForEdit}
              setRecordForEdit={setRecordForEdit}
              recordToDelete={recordToDelete}
              onDeleteSuccess={() => GetData(pageNumber)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
